var $6faa3defebc3eb72$exports = {};
$6faa3defebc3eb72$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Fargevelger",
  "colorSwatch": "fargekart",
  "transparent": "gjennomsiktig",
  "twoDimensionalSlider": "2D-glidebryter"
};
export { $6faa3defebc3eb72$exports as default };